function getTimestampMillis(value) {
  if (!value) return 0;
  if (value instanceof Date) return value.getTime();
  if (typeof value.toDate === "function") return value.toDate().getTime();
  if (value.seconds) return value.seconds * 1000;

  const parsed = new Date(value).getTime();
  return Number.isNaN(parsed) ? 0 : parsed;
}

export function getFormTitlePermanent(docOrForm) {
  return (
    docOrForm?.titlePermanent ||
    docOrForm?.formTitlePermanent ||
    docOrForm?.title ||
    docOrForm?.name ||
    ""
  );
}

export function getDefaultRecipientRoleGroup(role) {
  if (!role) return "";
  if (["Buyer", "Buyer 2", "Buyer 3"].includes(role)) return "Buyers";
  if (["Seller", "Seller 2", "Seller 3"].includes(role)) return "Sellers";
  return role;
}

function templateMatchesDefaultType(template, defaultType) {
  if (template.defaultEmailTemplateType) {
    return template.defaultEmailTemplateType === defaultType;
  }
  const legacyDefaultField =
    defaultType === "signing" ? "defaultForSigning" : "defaultForSharing";
  return template[legacyDefaultField] === true;
}

function templateAppliesToRecipientRole(template, recipientRole) {
  const recipientRoleGroup = getDefaultRecipientRoleGroup(recipientRole);
  if (!recipientRoleGroup) return false;

  if (!Array.isArray(template.defaultRecipientRoles)) return true;
  if (template.defaultRecipientRoles.length === 0) return true;

  return template.defaultRecipientRoles.includes(recipientRoleGroup);
}

export function findDefaultEmailTemplateForForm(
  emailTemplates,
  docOrForm,
  defaultType,
  recipientRole
) {
  const formTitlePermanent = getFormTitlePermanent(docOrForm);

  if (!formTitlePermanent || !defaultType || !Array.isArray(emailTemplates)) {
    return null;
  }

  const matchingTemplates = emailTemplates.filter(
    (template) =>
      template &&
      template.templateSource !== "manager" &&
      templateMatchesDefaultType(template, defaultType) &&
      template.defaultFormTitlePermanent === formTitlePermanent &&
      templateAppliesToRecipientRole(template, recipientRole)
  );

  if (matchingTemplates.length === 0) return null;

  return matchingTemplates.sort(
    (a, b) => getTimestampMillis(b.updatedAt) - getTimestampMillis(a.updatedAt)
  )[0];
}

export function getEmailTemplateSubject(emailTemplate, fallbackSubject) {
  return emailTemplate?.subject?.trim() || fallbackSubject;
}

export function getEmailTemplateMessage(emailTemplate, fallbackMessage) {
  return emailTemplate?.message?.trim() || fallbackMessage;
}